import moment from 'moment';
import { TimesheetStatus } from '../timesheet/Timesheet';

export const isEndDateValid = (timeOffRequest) =>
    Boolean(
        timeOffRequest &&
        (!timeOffRequest.endDate ||
            moment(timeOffRequest.endDate).isSameOrAfter(
                timeOffRequest.startDate,
                'day'
            ))
    );

export const isValid = (timeOffRequest) =>
    Boolean(
        timeOffRequest &&
        timeOffRequest.startDate &&
        timeOffRequest.timeOffReasonId &&
        (!timeOffRequest.isHalfDay ||
            (timeOffRequest.isHalfDay && !timeOffRequest.endDate)) &&
        isEndDateValid(timeOffRequest)
    );

export const isReadOnly = (timeOffRequest) =>
    Boolean(
        timeOffRequest &&
        timeOffRequest.id &&
        (!timeOffRequest.createdByCurrentUser ||
            timeOffRequest.timesheetStatusId > TimesheetStatus.New)
    );
